import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useState } from "react";
import { contactUs } from "../../api/parentApi";

const ContactForm = () => {
  const storedParent = localStorage.getItem("parentInfo");
  const isParentLoggedIn = !!storedParent;

  const initialMessage = isParentLoggedIn ? "We’re here to help you and your child make the most of MySchoolling 😊 \n\n For any questions about homework support, app usage, or your child’s progress, feel free to reach out to us anytime." : "Hi, can you please give us a short demo? I'd like to see how it works.";

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: initialMessage,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const validateForm = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!/^\+?\d{10,13}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid phone number";
    }

    if (formData.message.trim().length < 20) {
      newErrors.message = "Message must be at least 20 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSuccess(false);

    if (!validateForm()) return;

    setLoading(true);

    try {
      const response = await contactUs(formData);

      console.log("API Response:", response);

      setSuccess(true);

      setFormData({
        name: "",
        email: "",
        phone: "",
        message: initialMessage,
      });

      setErrors({});
    } catch (error) {
      console.error("Full Error:", error);

      setErrors({
        submit: `Failed: ${error.message}`,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Box sx={{ maxWidth: 600, mx: "auto" }}>
        <Typography variant="h5" fontWeight={700} mb={4}>
          Send Us a Message
        </Typography>

        {success && (
          <Alert severity="success" sx={{ mb: 3 }}>
            Your message has been sent successfully!
          </Alert>
        )}

        {errors.submit && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {errors.submit}
          </Alert>
        )}

        <TextField
          fullWidth
          label="Full Name"
          name="name"
          variant="outlined"
          margin="normal"
          value={formData.name}
          onChange={handleChange}
          error={!!errors.name}
          helperText={errors.name}
        />

        <TextField
          fullWidth
          label="Email Address"
          name="email"
          type="email"
          variant="outlined"
          margin="normal"
          value={formData.email}
          onChange={handleChange}
          error={!!errors.email}
          helperText={errors.email}
        />

        <TextField
          fullWidth
          label="Phone Number"
          name="phone"
          type="tel"
          variant="outlined"
          margin="normal"
          value={formData.phone}
          onChange={handleChange}
          error={!!errors.phone}
          helperText={errors.phone}
        />

        <TextField
          fullWidth
          label="Message"
          name="message"
          multiline
          rows={5}
          variant="outlined"
          margin="normal"
          value={formData.message}
          onChange={handleChange}
          error={!!errors.message}
          helperText={errors.message}
        />

        <Button
          fullWidth
          variant="contained"
          size="large"
          type="submit"
          disabled={loading}
          sx={{
            mt: 4,
            py: 1.6,
            borderRadius: 12,
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          {loading ? (
            <CircularProgress size={22} color="inherit" />
          ) : (
            isParentLoggedIn ? "Get Help" : "Request a Demo"
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default ContactForm;